export default "__VITE_ASSET__7d9ee0c7__"